// extracted by mini-css-extract-plugin
export default {"root":"root--zEYCP","left":"left--A_aBD","goBackButton":"goBackButton--ReLA1"};